import React from "react";
import * as s from "./index.module.scss";
import { IoArrowForward } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import Link from "next/link";
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";

const RolexWatches = ({ data }) => {
  return (
    <section className={s.rolex_watches}>
      <div className={s.rolex_watches_wrapper}>
        <article className={s.text_container}>
          <h4 className="heading fw-bold">{data?.title}</h4>

          <div className={s.sub_title}>
            <PrismicRichText
              field={data?.subTitle}
              components={{
                heading2: ({ children }) => <h3>{children}</h3>,
                heading3: ({ children }) => <h3>{children}</h3>,
              }}
            />
          </div>
          <div className="sub-title">
            <PrismicRichText field={data?.text} />
          </div>

          <div className={s.button_container}>
            <Link
              href="/what-we-buy/watch-buyers-nyc/rolex-watch-buyers"
              className={`btn btn-mob-pad btn-primary ${secondaryFont}`}
            >
              Go To Rolex{" "}
              <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
            </Link>
          </div>
        </article>
        <article className={s.image_container}>
          <PrismicNextImage
            className="h-100"
            loading="lazy"
            field={data?.image}
            fallbackAlt=""
          />
        </article>
      </div>
    </section>
  );
};

export default RolexWatches;
